var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.06977C0 3.16524 3.16525 0 7.06977 0C10.9743 0 14.1395 3.16524 14.1395 7.06977C14.1395 9.33094 13.078 11.3442 11.4261 12.6383C11.3935 12.689 11.3542 12.7366 11.3081 12.7797L7.55201 16.2948C7.26547 16.5629 6.81962 16.5614 6.53495 16.2912L2.83742 12.7825C2.79371 12.741 2.75622 12.6956 2.72492 12.6473C1.06646 11.3535 0 9.33616 0 7.06977ZM7.06979 7.99999C7.82001 7.99999 8.42819 7.39181 8.42819 6.6416C8.42819 5.89138 7.82001 5.2832 7.06979 5.2832C6.31957 5.2832 5.7114 5.89138 5.7114 6.6416C5.7114 7.39181 6.31957 7.99999 7.06979 7.99999Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationBlack);
export default __webpack_public_path__ + "static/media/icon-location-black.73e0e05fcd65ffe5a71c6b3f927292d3.svg";
export { ForwardRef as ReactComponent };